import Choices from 'choices.js';
import { ancestorBySelector } from "../../helpers/element/findAncestor";

function createSelect(selectBox, index) {
  const choice = new Choices(selectBox, {
    searchEnabled: (selectBox.dataset.choiceSearch === "true") ? true : false,
    itemSelectText: '',
    shouldSort: false,
    shouldSortItems: false,
    classNames: {
      containerOuter: (index !== 0) ? 'choices choices--product no-border-top' : 'choices choices--product'
    },

    callbackOnCreateTemplates: function (template) {
      return {
        choice: (classNames, data) => {
          let extras = null;

          if (data.customProperties !== null) {
            extras = JSON.parse(data.customProperties);
          }

          return template(`
            <div class="${classNames.item} ${classNames.itemChoice} 
            ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" 
            data-select-text="${this.config.itemSelectText}" data-choice 
            ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} 
            data-id="${data.id}" data-value="${data.value}" 
            ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
            ${(extras !== null && extras.thumb !== undefined) ? `<img src="${extras.thumb}" alt="" />` : ``}
              ${data.label}
            </div>
          `);
        },
      };
    },
  });

  selectBox.choice = choice;

  const variationsSelect = document.querySelector(`.variations #${selectBox.id}`);

  selectBox.addEventListener('choice', (event) => {

    // Activate Fields
    const parent = ancestorBySelector(selectBox, '.product-form__field');

    if (parent) {
      if (!event.detail.choice.placeholder) {
        parent.classList.add('is-active');
      } else {
        parent.classList.remove('is-active');
      }
    }

    const selectedValue = event.detail.choice.value;
    variationsSelect.value = selectedValue;

    [...variationsSelect.options].forEach((elem) => {

      if (elem.value === selectedValue) {
        elem.selected = true;
      }
    });

    const form = document.querySelector('.variations_form');
    form.dispatchEvent(new Event('reload_product_variations'));
    
  }, false);
}

export function initEcommsSelect() {
  const selectBoxes = document.querySelectorAll('.js-product-select select:not(.choices__input)');

  if (selectBoxes.length > 0) {
    selectBoxes.forEach((selectBox, i) => {
      createSelect(selectBox, i);
    });
  }
}